<template>
  <default-layout>
    <div class="max-w-screen-3xl">
      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        <div v-for="(info, index) in supportArray" :key="index">
          <supportCard :infoCard="info" :index="index" @goTo="clickOnButton" />
        </div>
      </div>
    </div>
    <virtual-pd-session-modal
      v-if="virtual_pd_session_modal"
      @close="virtual_pd_session_modal = false"
    />
    <virtual-class-visit-modal
      v-if="virtual_class_visit_modal"
      @close="virtual_class_visit_modal = false"
    />
    <content-concierge-modal
      v-if="content_concierge_modal"
      @close="content_concierge_modal = false"
    />
  </default-layout>
</template>

<script>
  import { mapGetters } from 'vuex';

  import defaultLayout from 'layouts/default/default.vue';
  import supportCard from './components/supportCard.vue';
  import virtualPdSessionModal from './components/virtualPdSessionModal.vue';
  import virtualClassVisitModal from './components/virtualClassVisitModal.vue';
  import contentConciergeModal from './components/contentConciergeModal.vue';

  export default {
    data() {
      return {
        supportArray: [
          {
            title: 'Virtual PD Session',
            image: 'static/support_&_PD/virtual_pd_session.svg',
            description:
              'A Parlay Instructional Strategist will facilitate a 1-hour interactive PD session for a group of teachers at your school or district.',
            button: 'Book a Session',
          },
          {
            title: 'Virtual Class Visit',
            image: 'static/support_&_PD/virtual_class_visit.svg',
            description:
              'A Parlay Instructional Strategist will help you plan and (virtually) co-facilitate a Written or Verbal RoundTable with your students!',
            button: 'Book a Visit',
          },
          {
            title: 'Content Concierge',
            image: 'static/support_&_PD/content_concierge.svg',
            description:
              'A Parlay Instructional Strategist will create a custom discussion topic for your class in as little as 24 hours.',
            button: 'Request Topic',
          },
          {
            title: 'Parlay Certified Educator',
            image: 'static/support_&_PD/parlay_certified_educator.svg',
            description:
              'A self-paced Certified Educator program where teachers facilitate RoundTables and are then asked to show proof of successful Parlay classroom implementation.',
            button: 'Get Certified',
          },
          {
            title: 'YouTube Channel',
            image: 'static/support_&_PD/youtube_channel.svg',
            description:
              'We`re always releasing new how-to and best practices videos for teachers and students on our YouTube channel.',
            button: 'Go To Youtube',
          },
          {
            title: 'Help Center',
            image: 'static/support_&_PD/help_center.svg',
            description:
              'The Parlay team keeps up to date documentation on all the major feautres and best practices for teachers in our help center.',
            button: 'Go To Help Center',
          },
          {
            title: 'Chat Support',
            image: 'static/support_&_PD/chat_support.svg',
            description:
              'The Parlay Team is always here to help! We offer real-time chat support to help you as you learn Parlay.',
            button: 'Start Chat',
          },
        ],
        virtual_pd_session_modal: false,
        virtual_class_visit_modal: false,
        content_concierge_modal: false,
      };
    },
    components: {
      defaultLayout,
      supportCard,
      virtualPdSessionModal,
      virtualClassVisitModal,
      contentConciergeModal,
    },
    computed: {
      ...mapGetters(['getProfile', 'getCourses']),
      upgraded_users() {
        return this.getProfile.is_paid;
      },
    },
    methods: {
      clickOnButton(index) {
        if (index === 0) {
          this.virtual_pd_session_modal = true;
        } else if (index === 1) {
          this.virtual_class_visit_modal = true;
        } else if (index === 2) {
          this.content_concierge_modal = true;
        } else if (index === 3) {
          window.open('https://forms.gle/FUz4gKT68UWvgcuS8', '_blank');
        } else if (index === 4) {
          window.open(
            'https://www.youtube.com/channel/UCSL35QQuSeYtdbz93DnDJxg/videos',
            '_blank'
          );
        } else if (index === 5) {
          window.open('https://parlay.crunch.help', '_blank');
        } else {
          window.HelpCrunch('openChat');
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// support_&_PD.vue?37278b9a